import { Outlet, Navigate } from "react-router-dom";
import SideMenu from "../../components/SideMenu";
import { useStytchMemberSession } from "@stytch/react/b2b";

const AppLayout = () => {
  const { session } = useStytchMemberSession();

  if (!session) {
    return <Navigate to="/auth/login" replace />;
  }

  return (
    <div className="flex min-h-dvh bg-gray-50">
      <SideMenu />
      <main className="flex-1 overflow-y-auto">
        <div className="max-w-7xl mx-auto p-4 md:p-6 lg:p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AppLayout;
